<script>
export default {
  name: 'Checkbox',
  props: {
    isCorrect: Boolean,
    isEnabled: Boolean,
  },
  data: () => ({
    isSelected: false
  }),
  mounted() { },
  methods: {
    onClick: function(event) {
      event.preventDefault();
      if (!this.isSelected && this.isEnabled) {
        this.$emit('clicked', event);
        this.isSelected = !this.isSelected;
      }
    }
  }
};
</script>

<template>
  <div class="checkbox" v-bind:class="{'checkbox--correct': isCorrect}" v-on:click="onClick($event)">
    <input class="checkbox__input" type="checkbox" v-bind:class="{'checkbox__input--selected': isSelected}" v-on:click="onClick">
    <svg class="checkbox__ring">
      <circle class="checkbox__base-circle" />
      <circle class="checkbox__circle" v-bind:class="{'checkbox__circle--hi': isSelected}" />
    </svg>
  </div>
</template>

<style lang="scss" scoped>

$PI: 3.14159265358979;
$borderWidth: 5px; //.3125rem; -> rem has a strange effect on svg stroke
$checkboxDimension: 71px; //4.375rem;
$borderLength: ($checkboxDimension * .5);

.checkbox {
  position: relative;
}

.checkbox__input {
  display: inline-block;
  position: relative;
  background-color: transparent;
  height: ($checkboxDimension + $borderWidth); width: ($checkboxDimension + $borderWidth);
  border: $borderWidth solid transparent;
  border-radius: 50%;
  margin: 0;
  cursor: pointer;
  outline: none;
  overflow: hidden;
  appearance: none;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  transform: rotate(-45deg);
}

.checkbox__input::before,
.checkbox__input::after {
  content: "";
  position: absolute;
  top: 50%; left: 50%;
  background: var(--dark);
  border-radius: .0625rem;
  transition: transform 400ms 200ms cubic-bezier(0.23, 1, 0.32, 1);
}

.checkbox__input::before {
  width: $borderWidth; height: $borderLength;
  margin: ($borderLength / -2) ($borderWidth / -2);
  transform: translateY(($checkboxDimension * 1.5));
}

.checkbox__input::after {
  height: $borderWidth; width: $borderLength;
  margin: ($borderWidth / -2) ($borderLength / -2) ;
  transform: translateX(($checkboxDimension * 1.5));
}

.checkbox__input--selected::before,
.checkbox__input--selected::after {
  transform: translate(0, 0);
}

.checkbox--correct {
  .checkbox__input::before,
  .checkbox__input::after {
    top: 54%; left: 50%;
  }

  .checkbox__input::before {
    width: $borderWidth; height: ($borderLength * 0.51);
    margin: ($borderLength / -2.3) (($borderLength / -2.3));
  }

  .checkbox__input::after {
    height: $borderWidth; width: $borderLength;
    margin: ($borderWidth / -2.3) ($borderLength / -2.3) ;
  }
}

.checkbox__ring {
  position: absolute;
  top: 0; left: 0;
  height: ($checkboxDimension + $borderWidth); width: ($checkboxDimension + $borderWidth);
  transform: rotate(-135deg);
  pointer-events: none;
}

.checkbox__circle,
.checkbox__base-circle {
  stroke-width: $borderWidth;
  stroke: var(--light);
  fill: transparent;
  r: (($checkboxDimension - $borderWidth) / 2);
  cx: (($checkboxDimension + $borderWidth) / 2);
  cy: (($checkboxDimension + $borderWidth) / 2);
}

.checkbox__circle {
  stroke: var(--dark);
  stroke-dasharray: ($checkboxDimension * $PI) ($checkboxDimension * $PI);
  stroke-dashoffset: ($checkboxDimension * $PI);
  transition: stroke-dashoffset 400ms 100ms cubic-bezier(0.23, 1, 0.32, 1);
}

.checkbox__circle--hi {
  stroke-dashoffset: 0
}

</style>